import Vue from 'vue'
import VueRouter from 'vue-router'
import protectRoute from '@/service/auth/auth'
import { canAccessRoute } from '@/utils/home-route'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/pages/LoginScreen/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/financeiro',
      name: 'financial',
      component: () => import('@/views/Financial.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/cobranca/minha/boleto/:id',
      name: 'myChargingIdBankSlip',
      component: () => import('@/views/pages/transaction/DetailsBankSlip.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/cobranca/minha/link-pagamento/:id',
      name: 'myChargingId',
      component: () => import('@/views/pages/transaction/DetailsTransaction.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/cobranca/minha/recorrencia/:id',
      name: 'myChargingIdRecurrence',
      component: () => import('@/views/pages/transaction/DetailsRecurrence.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/cobranca/minha',
      name: 'myCharging',
      component: () => import('@/views/pages/transaction/TransactionView.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: () => import('@/views/pages/Client/Client.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/clientes/novo',
      name: 'novosclientes',
      component: () => import('@/views/pages/Client/CreateClient.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/selecionar',
      name: 'select-merchant',
      component: () => import('@/views/pages/Merchant/SelectMerchant.vue'),
      meta: {
        requiresAuth: true,
        layout: 'full',
      },
    },
    {
      path: '/clientes/editar/:id',
      name: 'editarcliente',
      component: () => import('@/views/pages/Client/EditClient.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/fale-conosco',
      name: 'faleConosco',
      component: () => import('@/views/pages/contactUs/ContactUs.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/produtos',
      name: 'products',
      component: () => import('@/views/pages/products/Products.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/configuracao',
      name: 'profile',
      component: () => import('@/views/pages/AccountSetting/AccountSetting.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/permissoes',
      name: 'permission-management',
      component: () => import('@/views/pages/Permissions/PermissionManagement.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/primeiro-acesso',
      name: 'PrimeiroAcesso',
      component: () => import('@/views/pages/LoginScreen/FirstAccess.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/redefinir-senha/:hash',
      name: 'RedefinirSenha',
      component: () => import('@/views/pages/LoginScreen/ResetPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/esqueci-senha',
      name: 'EsqueciSenha',
      component: () => import('@/views/pages/LoginScreen/ForgotPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/novas-cobrancas',
      name: 'New-Charging',
      meta: {
        requiresAuth: true,
        requiresMerchant: true,
        layout: '',
      },
      component: () => import('@/views/pages/LinkGenerator/LinkGenerator.vue'),
    },
    {
      path: '/novas-cobrancas/:id',
      name: 'New-Charging-ID',
      meta: {
        requiresAuth: true,
        requiresMerchant: true,
        layout: '',
      },
      component: () => import('@/views/pages/LinkGenerator/LinkGenerator.vue'),
    },
    /*
     */
    {
      path: '/detalhes-transacao',
      name: 'detailsTransaction',
      component: () => import('@/views/pages/transaction/DetailsTransaction.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/detalhes-boleto',
      name: 'detailsBankSlip',
      component: () => import('@/views/pages/transaction/DetailsBankSlip.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/link-pagamento/1/:hash',
      name: 'linkPayment',
      component: () => import('@/views/pages/paymentLink/PaymentLink.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/link-pagamento/2/:hash',
      name: 'linkNext',
      component: () => import('@/views/pages/paymentLink/PaymentLinkNext.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/link-recorrencia/1/:hash',
      name: 'linkRecon',
      component: () => import('@/views/pages/paymentLink/PaymentRecurrence.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/link-recorrencia/2/:hash',
      name: 'linkReconNext',
      component: () => import('@/views/pages/paymentLink/PaymentRecurrenceNext.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/pagamento/status/:hash',
      name: 'linkstatus',
      component: () => import('@/views/pages/paymentLink/PaymentStatus.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/recorrencia/status/:hash',
      name: 'recurrenceStatus',
      component: () => import('@/views/pages/paymentLink/PaymentRecurrenceStatus.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/boleto/confirmado/:bar_code',
      name: 'Billet-Sucess',
      meta: {
        layout: '',
      },
      component: () => import('@/views/pages/LinkGenerator/Success.vue'),
    },
    {
      path: '/venda-direta/confirmado/:hash',
      name: 'DirectSale-Sucess',
      meta: {
        layout: '',
      },
      component: () => import('@/views/pages/LinkGenerator/Success.vue'),
    },
    {
      path: '/recorrencia/confirmado/:hash',
      name: 'Recurrence-Sucess',
      meta: {
        layout: '',
      },
      component: () => import('@/views/pages/LinkGenerator/Success.vue'),
    },
    {
      path: '/integracao',
      name: 'integration',
      meta: {
        requiresAuth: true,
        layout: '',
      },
      component: () => import('@/views/pages/Integration/Integration.vue'),
    },
    {
      path: '/detalhes',
      name: 'details-integration',
      meta: {
        layout: '',
      },
      component: () => import('@/views/pages/Integration/Details/Details.vue'),
    },
    {
      path: '/relatorio/grupo',
      name: 'relatorioGrupo',
      meta: {
        requiresAuth: true,
        layout: '',
      },
      component: () => import('@/views/pages/Report/Group.vue'),
    },
    {
      path: '/relatorio/transacao',
      name: 'relatorioTransacao',
      meta: {
        requiresAuth: true,
        layout: '',
      },
      component: () => import('@/views/pages/Report/Transaction.vue'),
    },
    {
      path: '/relatorio/recorrencia',
      name: 'relatorioRecorrencia',
      meta: {
        requiresAuth: true,
        layout: '',
      },
      component: () => import('@/views/pages/Report/Recurrence.vue'),
    },
    {
      path: '/relatorio/boleto',
      name: 'relatorioBoleto',
      meta: {
        requiresAuth: true,
        layout: '',
      },
      component: () => import('@/views/pages/Report/BankSlip.vue'),
    },
    {
      path: '/cadastro/detalhes/:hash',
      name: 'details',
      component: () => import('@/views/pages/RegisterOnline/Details/Details.vue'),
      meta: {
        layout: 'full',
      },
    },
     {
      path: '/revisar-termos',
      name: 'review-terms',
      component: () => import('@/views/pages/LoginScreen/TermsReview.vue'),
      meta: {
        requiresAuth: true,
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/acesso-negado',
      name: 'access-denied',
      component: () => import('@/views/error/NoPermission.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})


router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const result = await protectRoute(to, from)

    if (result?.redirect) {
      next(result.redirect)
      return
    }

    if (!canAccessRoute(to.name)) {
      next({ name: 'access-denied' })
      return
    }
  }
  next()
})

//

router.afterEach(() => {
  // Remove initial loading
  // console.log("Depois", to.meta);
  
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'

    // inactivityTime();
  }
  // awayUser()
})

/* function awayUser() {
  let seconds = 0;

  ["mousemove", "scroll", "wheel", "touchmove", "keyup"].forEach(function (event) {
    document.addEventListener(event, function () {
      seconds = 0;
    });
  });

  setInterval(function () {
    seconds = seconds + 1;
    if (seconds == 900000)
      logout()
    alert("Você ficou inativo durante 15 minutos, faça o login novamente para realizar suas operações");
  }, 900000);
} */

export default router
